import {
    dataForEthnicity,
    dataForGender,
    dataForMartialStatus, dataForNotificationPreference,
    dataForPreferenceLanguage,
    dataForRace, dataForState,
} from "./datasource";
import {DropdownItem} from "../components/form/dropdown";

export enum ElementID {
    name = "name",
    phoneNumber = "phoneNumber",
    dob = "dob",
    race = "race",
    ethnicity = "ethnicity",
    marriageStatus = "marriageStatus",
    gender= "gender",
    email = "email",
    language= "language",
    notification = "notification,",
    address = "address",
    insurance = "insurance",
}

export interface PatientInfo {
    name: string,
    patientGender: DropdownItem,
    patientDOB: string,
    patientFirstName: string,
    patientLastName: string,
    patientAddrStreet: string,
    patientAddrStreet2: string,
    patientAddrCity: string,
    patientAddrState: DropdownItem,
    patientAddrZip: string,
    patientMobilePhone: string,
    patientEMail: string,
    patientID: number,
    MPatientID: number,
    clinicID: number,
    updateID: number,
    appointmentID: number,
    patientMarrage: DropdownItem,
    language: DropdownItem,
    race: DropdownItem,
    ethnicity: DropdownItem,
    contactMethod: DropdownItem,
    insuranceCardBackBase64: string | null,
    insuranceCardFrontBase64: string | null,
    tokenID: string | null,
}

export const defaultPatientInfo: PatientInfo = {
    name: "",
    appointmentID: 0,
    updateID: 0,
    clinicID: 0,
    patientDOB: "",
    patientGender: dataForGender[0],
    language: dataForPreferenceLanguage[0],
    patientAddrCity: "",
    patientAddrState: dataForState[0],
    patientAddrStreet: "",
    patientAddrStreet2: "",
    patientAddrZip: "",
    patientEMail: "",
    patientFirstName: "",
    patientID: 0,
    MPatientID: 0,
    patientLastName: "",
    patientMarrage: dataForMartialStatus[0],
    patientMobilePhone: "",
    race: dataForRace[0],
    ethnicity: dataForEthnicity[0],
    contactMethod: dataForNotificationPreference[0],
    insuranceCardBackBase64: null,
    insuranceCardFrontBase64: null,
    tokenID: "",
}

export enum Language {
    en = "en",
    zh = "zh",
    sp = "esp"
}

export enum Page {
    unknown,
    contact,
    birthday,
    profile,
    intakeForm,
    consentForm,
    verifyFailed,
    checkIn
}

export interface Appointment {
    doctorName: string,
    appointmentDate: string,
    isOfficeVisit: boolean,
    clinicName: string,
    clinicPhone: string,
    locationID: number,
    address: string,
}

export const defaultAppointment: Appointment = {
    clinicName: "Test Clinic", clinicPhone: "123-123-123-1234", appointmentDate: "Friday, Jun 08, 9:30 am EDT", doctorName: "Amy Chiu, M.D.", isOfficeVisit: false, locationID: 0, address: "",
}
